import React from "react";
import { Route } from "react-router-dom";
import { useAuth } from "../../context/auth-context";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../errorHandling/error-fallback-page";
import { handleBoundaryError } from '../../utils/globalErrorHandler';
import { useAuthCheck } from "../../context/auth-check-context";
import RouteLoadingSpinner from "../loading/RouteLoadingSpinner";
import LoginRedirect from "./LoginRedirect";

/**
 * AdvisorRoute - Route wrapper that requires both authentication and advisor privileges.
 * Shows a loading spinner while the auth check is in progress.
 * Redirects to `/login` if the user is unauthenticated or lacks advisor access.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.component - The component to render for authorized advisors.
 * @returns {JSX.Element}
 */
export default function AdvisorRoute({ component: Component, ...rest }) {
  const { currentUser } = useAuth();
  const { isAdvisor, loading } = useAuthCheck();

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleBoundaryError}>
      <Route
        {...rest}
        render={(props) => {
          if (loading) return <RouteLoadingSpinner />;
          return currentUser && isAdvisor ? (
            <Component {...props} />
          ) : (
            <LoginRedirect />
          );
        }}
      />
    </ErrorBoundary>
  );
}
